<template>
    <div class="plan-table">
        <table v-for="group in items" class="table table-sm table-nowrap" style="width:100%">
            <thead>
            <tr>
                <th scope="col"></th>
                <th scope="col" class="text-center" style="width: 15%">{{ $t('Teeth') }}</th>
                <th scope="col" style="width:65%">{{ $t('Service') }}</th>
                <th scope="col" class="text-center">{{ $t('Quantity') }}</th>
                <th scope="col" class="text-right">{{ $t('Cost') }}</th>
                <th scope="col" class="text-right">{{ $t('Total') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, itemIndex) in group" :key="itemIndex" class="page-break-after">
                <td :class="{'border-top': item.rowspan}" style="border-top: none;">
                    <span v-if="item.rowspan" class="vertical-text text-muted h2">
                        {{ $t("Stage") }} {{ item.stage }}
                    </span>
                </td>

                <td class="text-center word-break">{{ item.teeth.join(', ') }}</td>
                <td class="long-name" :style="leftBorderColor(item)">
                    {{ item.treatment.label }}
                </td>
                <td class="text-center">{{ item.quantity || 1 }}</td>
                <td class="text-right">
                    <money :value="item.treatment.price||0"></money>
                </td>
                <td class="text-right">
                    <money :value="(item.treatment.price || 0) * (item.quantity || 1)"></money>
                </td>
            </tr>
            <tr v-for="(colorGroup, groupIndex) in (groupByColor ? [group] : colorGroups)">
                <td class="border-0"></td>
                <td colspan="4" class="">
                    <strong>{{ $t('Total') }} ({{groupIndex + 1}})</strong>
                </td>
                <td class="text-left">
                    <span class="h3" :style="priceStyle(colorGroup)">
                        <money :value="totalPrice(colorGroup)"></money>
                    </span>
                </td>
            </tr>
            <tr v-if="!groupByColor && !colorGroups.length">
                <td class="border-0"></td>
                <td colspan="4" class="">
                    <strong>{{ $t('Total') }}</strong>
                </td>
                <td class="text-left">
                    <span class="h3">
                        <money :value="totalPrice(items[0])"></money>
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>

import Money from "@/components/Money";
import {totalPrice, priceStyle} from "@/Pages/People/Customer/TreatmentPlan/utils";

export default {
    name: "PlanTable",
    components: { Money },
    props: { teeth: Array, colorGroups: Array, groupByColor: Boolean },
    data() {
        return {}
    },
    watch: {},
    methods: {
        totalPrice(items) {
            return totalPrice(items)
        },

        priceStyle(items) {
            return priceStyle(items)
        },

        leftBorderColor(item) {
            if (this.groupByColor) {
                return ''
            }
            return { 'border-left': '5px solid ' + (item.color || '#f8f8f8') }
        }
    },
    computed: {
        items() {
            if (!this.teeth) return [];
            if (this.groupByColor)
                return this.colorGroups
            else
                return this.teeth;
        }
    }
}
</script>

<style lang="scss">
</style>

<style scoped>
.vertical-text {
    writing-mode: vertical-lr;
    -ms-writing-mode: tb-rl;
    transform: rotate(180deg);
}

.long-name {
    white-space: unset !important;
}

.word-break {
    word-break: keep-all;
    white-space: pre-line;
}
</style>
